import React, { useState } from "react";
import styled from "styled-components";
import ArrowForward from "../../images/arrow_forward.svg";

const StyledWrapper = styled.section`
  background-color: #ffffff;
  margin: 0 0 128px 6.59vw;
  color: #000000;
  font-family: Inter;
  font-weight: 400;
  letter-spacing: 0em;

  @media (max-width: 768px) {
    margin: 0 16px 137px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .mobile-container {
    @media (max-width: 768px) {
      max-width: 382px;
    }
  }

  .heading {
    font-size: 45px;
    font-weight: 700;
    line-height: 44px;
    letter-spacing: -0.02em;
    text-align: left;

    @media (max-width: 768px) {
      font-size: 32px;
      font-weight: 700;
      line-height: 40px;
      letter-spacing: 0em;
    }
  }

  .overal-rating-container {
    background-color: #fcfbfb;
    padding: 8px 26px 13px 15px;
    margin: 23px 0 25px 0;
    display: flex;
    align-items: center;
    border: 1px solid #cdcdcd;
    border-radius: 15px;
  }

  .overal-rating-value {
    font-size: 36px;
    font-weight: 700;
    line-height: 44px;
    text-align: center;
    padding: 0 10px;
    color: #6f3500;
    @media (max-width: 768px) {
      font-weight: 400;
    }
  }

  .gold-stars {
    color: #f0ad00;
    line-height: 21.33px;
    font-size: 18px;
  }

  .google-rating {
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: left;
  }

  .reviews-container-outer {
    width: 100%;
    overflow-x: scroll;
    scrollbar-width: none;
  }

  .reviews-container {
    display: flex;
    width: 2500px;
    padding-right: 100px;
    @media (max-width: 768px) {
      flex-direction: column;
      width: unset;
      padding-right: 0;
      align-items: center;
    }
  }

  .review-container {
    width: 450px;
    height: 266px;
    padding: 19px 41px 80px 24px;
    background-color: #ffffff;
    border: 2px solid #cdcdcd;
    border-radius: 16px;
    margin-left: 20px;
    :first-child {
      margin-left: 0;
    }
    @media (max-width: 768px) {
      width: unset;
      max-width: 382px;
      padding: 19px 19px 80px 24px;
      height: auto;
      margin-left: 0px;
      margin-bottom: 16px;
    }
  }

  .review-img-name {
    display: flex;
    width: 100%;
    align-items: center;
  }

  .review-img {
    height: 53px;
    width: 53px;
    border-radius: 26.5px;
    background-color: #7d98cd;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 500;
    font-size: 20px;
  }

  .review-name {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
    margin-left: 11px;
  }

  .green-stars {
    color: #0f9d58;
    margin: 8px 0;
    display: flex;
    align-items: center;

    font-size: 24px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0em;
    text-align: center;
  }

  .review-date {
    color: #000000;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: left;
    margin-left: 9px;
  }

  .review-content {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
  }
  .see-more-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 18px 20px 0 0;
    @media (max-width: 768px) {
      margin: 18px 0 0;
    }
  }

  .see-more {
    background-color: #ffc3aa;
    padding: 13px 22px 12px 23px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 133px;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0.06em;
    text-align: center;
    border-radius: 46px;
  }
`;

const REVIEW_JSON = [
  {
    name: "vinu H",
    date: "04/01/2022",
    content:
      "One of the best apps which provide a easy way to get money without any risk. Can be referred to anyone, who in need. This app is very easy, accessible, referable and enjoyable.",
  },
  {
    name: "Rajiv Puri",
    date: "06/01/2022",
    content:
      "Seeing this app was like a discovery. Excellent app, very useful for instant cash. Wish others could follow suit.",
  },
  {
    name: "Vardhaman Kothari",
    date: "20/12/2021",
    content:
      "Smooth experience ... Awesome experience just takes few minutes to apply for loan and amazing support staff.",
  },
  {
    name: "Megha Shetty",
    date: "16/12/2021",
    content:
      "Amazing app for PPL who need instant credit Very good service, really helpful to fulfill your needs in emergency 🦺",
  },
  {
    name: "Mujaheed Chitgi",
    date: "16/12/2021",
    content:
      "Very helpful app...i got a loan with good interest rate and closed it with no fore closing charges",
  },
];

const RatingAndReviews = () => {
  const [showMore, setShowMore] = useState(false);
  const handleSeeMore = () => {
    const element = document.getElementById("reviewsContainer");
    if (element?.offsetWidth < 718) {
      setShowMore(true);
    } else if (element?.scrollLeft < 2500 - element?.offsetWidth) {
      element.scrollLeft = 2500 - element?.offsetWidth;
    }
  };
  const data = showMore ? REVIEW_JSON : REVIEW_JSON.slice(0, 3);
  return (
    <StyledWrapper>
      <div className="mobile-container">
        <div className="heading">We are thankful to our customers:</div>
        <div className="d-flex">
          <div className="overal-rating-container">
            <div className="overal-rating-value">5.0</div>
            <div>
              {/* <img src={GoldStarsImg} alt="" /> */}
              <div className="gold-stars">★★★★★</div>
              <div className="google-rating">Google Rating</div>
            </div>
          </div>
        </div>
        <div className="reviews-container-outer" id="reviewsContainer">
          <div className="reviews-container d-none d-md-flex">
            {REVIEW_JSON.map((review, index) => (
              <div className="review-container" key={index}>
                <div className="review-img-name">
                  <div className="review-img">
                    {review.name[0].toUpperCase()}
                  </div>
                  <div className="review-name">{review.name}</div>
                </div>
                <div className="green-stars">
                  ★★★★★ <span className="review-date">{review.date}</span>
                </div>
                <div className="review-content">{review.content}</div>
              </div>
            ))}
          </div>
          <div className="reviews-container d-flex d-md-none">
            {data.map((review, index) => (
              <div className="review-container" key={index}>
                <div className="review-img-name">
                  <div className="review-img">
                    {review.name[0].toUpperCase()}
                  </div>
                  <div className="review-name">{review.name}</div>
                </div>
                <div className="green-stars">
                  ★★★★★ <span className="review-date">{review.date}</span>
                </div>
                <div className="review-content">{review.content}</div>
              </div>
            ))}
          </div>
        </div>
        {!showMore && (
          <div className="see-more-container">
            <div className="see-more" onClick={() => handleSeeMore()}>
              <div>MORE</div>
              <img src={ArrowForward} alt="" />
            </div>
          </div>
        )}
      </div>
    </StyledWrapper>
  );
};

export default RatingAndReviews;
